/** Register | My tasks (E4 spec D24, wireframe decision 17): one page, two
 * views over the same records. Links, so each view is a URL.
 *
 * SA-1184: a custom module's register view is a toggle in the register
 * toolbar, not a third link here; with it on, Register is the current view. */
import { Link } from 'react-router-dom'
import { cn } from '@/utils'
import { TAB_SELECTED_CLASS } from '@/components/ui/Tabs'
import { tourAnchor } from '@/components/tour/tourAnchor'

// SA-1124: the basis Tabs list's look. SA-1184: the selected link is the shared
// Tabs' raised card (TAB_SELECTED_CLASS, SA-1132), read through data-state as
// the basis trigger reads it; the transparent resting border keeps a selection
// from moving anything. Never a filled primary pill (SA-1123).
const TAB = cn(
  'rounded-md border border-transparent px-3 py-1 text-sm font-medium transition-colors',
  'text-muted-foreground hover:text-foreground',
  'data-[state=active]:text-foreground data-[state=active]:shadow-sm',
  TAB_SELECTED_CLASS,
)

export function RecordViewSwitch({ view }: { view: 'register' | 'tasks' }) {
  const tab = (name: 'register' | 'tasks', label: string, to: string) => (
    <Link
      to={to}
      aria-current={view === name ? 'page' : undefined}
      data-state={view === name ? 'active' : 'inactive'}
      className={TAB}
    >
      {label}
    </Link>
  )
  return (
    <nav aria-label="Views" {...tourAnchor('records.toolbar.views')} className="inline-flex gap-1 rounded-lg bg-muted p-[3px]">
      {tab('register', 'Register', '/orders')}
      {tab('tasks', 'My tasks', '/orders?view=tasks')}
    </nav>
  )
}
